import React from 'react'

function FAQ() {
    const css_padding ={paddingBottom: '20px'}
  return (
    <div id="faq" className="basic-1">
        <div className="container">
            <div className="row">
                <div className="col-lg-12">
                    <h1 className="blue text-center" style={css_padding}>Frequently Asked Questions</h1>
                    <ul id="accordion" className="col-sm-6 col-md-12">
                        <li>
                            <div id="choose" className="q" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true"
                                aria-controls="collapseOne">
                                How quickly can we see results from AI implementation?
                                <span className="fa fa-chevron-up fa-1x text-info pull-right"></span>
                            </div>
                            <div id="collapseOne" className="collapse show" aria-labelledby="headingOne" data-parent="#accordion">
                                <div className="card-body">
                                Most organizations begin seeing <b>measurable improvements within 30-60 days</b> of initial deployment.
                                <br /><br />
                                However, the timeline varies based on the complexity of your existing systems and the scope of AI integration. Our <b>phased approach</b> ensures you experience value at each stage of implementation, with many clients achieving <b>25-40% productivity improvements</b> within six months.
                                </div>
                            </div>
                        </li>

                        <li>
                        <div className="q" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false"
                            aria-controls="collapseTwo">
                            Is our data secure with AI and blockchain solutions?
                            <span className="fa fa-chevron-down fa-1x text-info pull-right"></span>
                        </div>
                        <div id="collapseTwo" className="collapse" aria-labelledby="headingTwo" data-parent="#accordion">
                            <div className="card-body">
                            <b>Security is our top priority.</b> Our solutions include enterprise-grade encryption, secure data handling protocols, and blockchain-based immutable audit trails.
                            <br /><br />
                            We comply with all major data protection regulations including:
                            <ul>
                                <li><b>GDPR</b> and <b>CCPA</b> compliance</li>
                                <li>Industry-specific requirements (HIPAA, SOX, etc.)</li>
                                <li><b>Enterprise-grade encryption</b> for all data transfers</li>
                                <li><b>Blockchain-secured</b> audit trails for transparency</li>
                            </ul>
                            <br />
                            Your data remains within your control, and our <b>Model Context Protocol</b> integration ensures secure connections without compromising data integrity.
                            </div>
                        </div>
                        </li>

                        <li>
                        <div className="q" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false"
                            aria-controls="collapseThree">
                            Do we need to replace our existing systems to implement AI?
                            <span className="fa fa-chevron-down fa-1x text-info pull-right"></span>
                        </div>
                        <div id="collapseThree" className="collapse" aria-labelledby="headingThree" data-parent="#accordion">
                            <div className="card-body">
                            <b>Not at all.</b> Our solutions are designed to integrate seamlessly with your existing technology stack.
                            <br /><br />
                            Using <b>Model Context Protocol</b> and standard APIs, we connect AI capabilities to your current systems without requiring costly replacements or major disruptions. This approach minimizes implementation time and maximizes ROI.
                            </div>
                        </div>
                        </li>

                        <li>
                        <div className="q" data-toggle="collapse" data-target="#collapseFour" aria-expanded="false"
                            aria-controls="collapseFour">
                            What kind of ROI can we expect from AI implementation?
                            <span className="fa fa-chevron-down fa-1x text-info pull-right"></span>
                        </div>
                        <div id="collapseFour" className="collapse" aria-labelledby="headingFour" data-parent="#accordion">
                            <div className="card-body">
                            While results vary by industry and implementation scope, our clients typically see <b>25-40% productivity improvements</b> within six months.
                            <br /><br />
                            The global AI market represents a <b>$4.4 trillion opportunity</b>, and our solutions are designed to help you capture your share of this value. Many clients achieve <b>payback periods as short as 3-4 months</b> for high-impact use cases.
                                 </div>
                        </div>
                        </li>

                        <li>
                        <div className="q" data-toggle="collapse" data-target="#collapseFive" aria-expanded="false"
                            aria-controls="collapseFive">
                            How do you ensure AI agents make accurate decisions?
                            <span className="fa fa-chevron-down fa-1x text-info pull-right"></span>
                        </div>
                        <div id="collapseFive" className="collapse" aria-labelledby="headingFive" data-parent="#accordion">
                            <div className="card-body">
                            Our AI agents use <b>advanced reasoning capabilities</b> and are trained on comprehensive datasets specific to your industry and business context.
                            <br /><br />
                            We implement multiple validation layers, continuous monitoring, and human oversight protocols to ensure accuracy and reliability. Our agents typically achieve <b>35% improvement in task accuracy</b> compared to manual processes.
                            </div>
                        </div>
                        </li>

                        <li>
                        <div className="q" data-toggle="collapse" data-target="#collapseSix" aria-expanded="false"
                            aria-controls="collapseSix">
                            Can small businesses benefit from these advanced AI solutions?
                            <span className="fa fa-chevron-down fa-1x text-info pull-right"></span>
                        </div>
                        <div id="collapseSix" className="collapse" aria-labelledby="headingTwo" data-parent="#accordion">
                            <div className="card-body">
                            <b>Absolutely.</b> We offer scalable solutions designed for businesses of all sizes.
                            <br /><br />
                            Our modular approach allows smaller organizations to start with specific use cases and expand their AI capabilities as they grow and see results. We provide flexible pricing models to ensure enterprise-grade AI is accessible to every business.
                            </div>
                        </div>
                        </li>

                        <li>
                        <div className="q" data-toggle="collapse" data-target="#collapseSeven" aria-expanded="false"
                            aria-controls="collapseSeven">
                            What is Model Context Protocol (MCP) and why is it important?
                            <span className="fa fa-chevron-down fa-1x text-info pull-right"></span>
                        </div>
                        <div id="collapseSeven" className="collapse" aria-labelledby="headingTwo" data-parent="#accordion">
                            <div className="card-body">
                            <b>MCP is an open standard</b> developed by Anthropic that connects AI assistants to the systems where data lives.
                            <br /><br />
                            It eliminates data silos and provides a universal way for AI systems to access and understand your business data, resulting in <b>45% improvement in AI response accuracy</b> and <b>70% reduction in data integration time</b>.
                            </div>
                        </div>
                        </li>
                        
                        <li>
                        <div className="q" data-toggle="collapse" data-target="#collapseEight" aria-expanded="false"
                            aria-controls="collapseEight">
                            How do we get started with FalconEye AI Solutions?
                            <span className="fa fa-chevron-down fa-1x text-info pull-right"></span>
                        </div>
                            <div id="collapseEight" className="collapse" aria-labelledby="headingTwo" data-parent="#accordion">
                            <div className="card-body">
                            Getting started is simple: <b>Schedule a consultation</b> with our AI experts to discuss your specific business challenges and opportunities.
                            <br /><br />
                            We'll provide a <b>custom assessment</b> of your AI readiness and implementation recommendations, followed by a detailed proposal outlining solutions, timeline, and investment requirements. Our proven methodology ensures successful AI transformation from day one.
                            </div>
                        </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
  </div>
  )
}

export default FAQ